import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "@app/../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { filter, finalize } from "rxjs";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrl: "./app.component.css",
	standalone: false
})
export class AppComponent {
	title = "clickarbiz-inter-frontend";

	constructor(
		public translate: TranslateService,
		public router: Router,
		private storageService: StorageManagerService
	) {
		this.translate.addLangs(environment.languages);

		const defaultLang = () => {
			this.translate.setFallbackLang("en-IT");
		}; // NOTE: non so se merita inserirla: scarica comunque un JSON in più
		// console.log("app component loaded");
		if (this.storageService.hasSessionItem(SessionKey.USER_LANGUAGE)) {
			const lang = `${(this.storageService.getSessionItem(SessionKey.USER_LANGUAGE, "en") as string).toLowerCase()}-${(this.storageService.getSessionItem(SessionKey.USER_MARKET, "IT") as string).toUpperCase()}`;
			// console.log("app component language session", language);

			this.translate.use(
				environment.languages.includes(lang) ?
					lang :
					"en-IT"
			).pipe(
				finalize(defaultLang)).subscribe();
		} // First landing and mobile login enter here
		else {
			let browserLang = this.translate.getBrowserCultureLang(),
				completeBrowserLang = browserLang;
			if (browserLang.length === 2) { // e.g. "it" or "IT"
				browserLang = browserLang.toLowerCase();
				completeBrowserLang += `-${browserLang.toUpperCase()}`; // getting "it-IT"
			}
			else {
				browserLang = browserLang.slice(0, 2); // if it's it-IT, getting "it"
			}
			// console.log("app component lang to use", langToUse);
			this.translate.use(
				environment.languages.includes(completeBrowserLang) ? // if the ISO 8601 language is available
					completeBrowserLang : // if the ISO 8601 language is available
					environment.languages.find(l => l.startsWith(browserLang)) ?? "en-IT" // Otherwise we find the first with the "pure" two-characters lang, fallback to en-it
			)
				.pipe(finalize(defaultLang)).subscribe();
		}

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				// console.log("navigation event: ", event);
				document.body.classList[
					(["/admin", "/registration"].some(basePath => event.urlAfterRedirects.startsWith(basePath))) ?
						"add" :
						"remove"
				]
					("pt-0");
			});
	}
}